import React from "react";
import { VerifiedUser } from "@material-ui/icons";
import { Colors } from "../../theme/Theme";
import { renderRBPayText } from "../../components/RBPayWordmark";

/**
 * Small "RB Pay Verified" chip shown on Worker Shift Search cards when the shift's
 * location has an approved RB Payroll setup. Styled to sit quietly inside the card
 * (green = verified/active, matching the rest of the app) rather than as a loud pill.
 */
export const RBPayrollVerifiedBadge: React.FC<{ style?: React.CSSProperties }> = ({
  style,
}) => (
  <div
    style={{
      display: "inline-flex",
      alignItems: "center",
      gap: 4,
      backgroundColor: "#EAF7EC",
      border: `1px solid ${Colors.themeGreen}`,
      borderRadius: 6,
      padding: "2px 8px",
      lineHeight: 1,
      ...style,
    }}
  >
    <VerifiedUser style={{ fontSize: 14, color: Colors.themeGreen }} />
    <span
      style={{
        color: Colors.themeGreen,
        fontSize: 12,
        fontWeight: 600,
        whiteSpace: "nowrap",
      }}
    >
      {renderRBPayText("RB Pay Verified")}
    </span>
  </div>
);
